import $ from 'jquery';
import {showFormResponse} from '../common/json-response';
import {initWorkContentWysiwyg, initWysiwyg} from "./wysiwyg";
import {uuidv4} from '../common/uuid';

function disableUncheckedInputs() {
  const fieldFormats = document.querySelectorAll('.custom_field_format');

  fieldFormats.forEach(function (formatInput) {
    if (formatInput.checked) {
      return;
    }

    const fieldUuidAttr = '[data-custom-field-uuid="' + formatInput.getAttribute('data-custom-field-uuid') + '"]';
    const fieldFormatAttr = '[data-custom-field-format="' + formatInput.getAttribute('data-custom-field-format') + '"]';
    const customFieldBlock = formatInput.closest('.custom_field_block');
    const paramsSelector = '.custom_field_params' + fieldUuidAttr + fieldFormatAttr;
    const params = customFieldBlock.querySelectorAll(paramsSelector);
    params.forEach(function (paramsBlock) {
      paramsBlock.style.display = 'none';
      const paramsInputs = paramsBlock.querySelectorAll('input');
      paramsInputs.forEach(function (element) {
        element.disabled = true;
      });
    });
  });
}

function toggleRequiredAndPublicCheckboxes(customFieldBlock, fieldUuid, show) {
  const fieldCommonParamsBlock = customFieldBlock.querySelector('.common_parameters[data-custom-field-uuid="' + fieldUuid + '"]');
  const fieldRequiredCheckbox = customFieldBlock.querySelector('[name="custom_fields[' + fieldUuid + '][required]"]');

  if (!fieldRequiredCheckbox || !fieldCommonParamsBlock) {
    return;
  }

  const fieldPublicCheckbox = customFieldBlock.querySelector('[name="custom_fields[' + fieldUuid + '][public_for_all]"]');
  const fieldPublicForJudgeCheckbox = customFieldBlock.querySelector('[name="custom_fields[' + fieldUuid + '][public_for_judge]"]');

  if (!fieldPublicCheckbox || !fieldPublicForJudgeCheckbox) {
    return;
  }

  const fieldRequiredCheckboxParent = fieldRequiredCheckbox.closest('[data-message-parent-id]');
  const fieldPublicCheckboxParent = fieldPublicCheckbox.closest('[data-message-parent-id]');
  const fieldPublicForJudgeCheckboxParent = fieldPublicForJudgeCheckbox.closest('[data-message-parent-id]');

  if (!fieldRequiredCheckboxParent || !fieldPublicCheckboxParent || !fieldPublicForJudgeCheckboxParent) {
    return;
  }

  if (show) {
    fieldCommonParamsBlock.classList.remove('d-none');
    fieldRequiredCheckboxParent.classList.remove('d-none');
    fieldPublicCheckboxParent.classList.remove('d-none');
    fieldPublicForJudgeCheckboxParent.classList.remove('d-none');
  } else {
    fieldCommonParamsBlock.classList.add('d-none');
    fieldRequiredCheckbox.checked = false;
    fieldPublicCheckbox.checked = false;
    fieldPublicForJudgeCheckbox.checked = false;
    fieldRequiredCheckboxParent.classList.add('d-none');
    fieldPublicCheckboxParent.classList.add('d-none');
    fieldPublicForJudgeCheckboxParent.classList.add('d-none');
  }
}

function removeCustomFieldHandler(e) {
  e.preventDefault();
  const button = e.currentTarget;
  const fieldUuid = button.getAttribute('data-custom_field_uuid');
  const fieldType = button.getAttribute('data-custom_field_type');
  const contestHashId = button.getAttribute('data-contest_hash_id');

  $.ajax({
    type: 'POST',
    data: {'uuid': fieldUuid, 'type': fieldType},
    url: '/cabinet/contests/' + contestHashId + '/work-settings/custom-fields/delete/',
    success: function (data) {
      if (data.redirectTo?.length) {
        window.location.href = data.redirectTo;
      }

      showFormResponse(data);

      if (data.status !== 'success') {
        return;
      }

      const fieldSelector = '.custom_field_block[data-custom-field-uuid="' + fieldUuid +'"';
      const customFieldBlock = document.querySelector(fieldSelector);
      customFieldBlock.remove();
    },
    error: function (data) {
      showFormResponse(data);
    },
  });
}

function removeNewCustomFieldHandler(e) {
  e.preventDefault();
  const button = e.target;
  const fieldUuid = button.getAttribute('data-custom_field_uuid');
  const customFieldBlock = document.querySelector('.filled_custom_field_block[data-custom-field-uuid="' + fieldUuid + '"]');
  customFieldBlock.remove();

  const statusMsg = document.createElement('div');
  statusMsg.classList.add(['alert']);
  statusMsg.classList.add(['alert_success']);
  statusMsg.innerHTML = 'Настраиваемое поле удалено';
  const statusWrapper = document.querySelector('.action-status-messages');
  statusWrapper.appendChild(statusMsg);
}

function removeFieldVariantHandler(e) {
  e.preventDefault();
  const button = e.currentTarget;
  const fieldUuid   = button.getAttribute('data-custom-field-uuid');
  const fieldType   = button.getAttribute('data-custom-field-format');
  const contestHashId = button.getAttribute('data-contest-hash-id');
  const variantUuid   = button.getAttribute('data-custom-field-variant-uuid');

  $.ajax({
    type: 'POST',
    data: {fieldUuid, fieldType, variantUuid},
    url: '/cabinet/contests/' + contestHashId + '/work-settings/custom-field-variant/delete',
    success: function (data) {
      if (data.redirectTo?.length) {
        window.location.href = data.redirectTo;
      }

      showFormResponse(data);

      if (data.status !== 'success') {
        return;
      }

      const fieldSelector = '.custom_field_block[data-custom-field-uuid="' + fieldUuid + '"]';
      const field = document.querySelector(fieldSelector);
      const fieldVariantSelector = 'input[data-custom-field-variant-uuid="' + variantUuid + '"]';
      const customFieldVariant = field.querySelector(fieldVariantSelector);
      const customFieldVariantsBlock = customFieldVariant.closest('.field_variants');
      customFieldVariant.closest('li').remove();

      // Если больше нет вариантов скрываем определенные параметры
      const otherVariants = customFieldVariantsBlock.querySelectorAll('.variant_item');

      if (!otherVariants.length) {
        const customFieldsParams = customFieldVariantsBlock.closest('.custom_field_params');
        const labelUseVariantsScore = customFieldsParams.querySelector('.label_use_variants_score');
        labelUseVariantsScore?.classList.add('d-none');
        const labelShowVariantsScore = customFieldsParams.querySelector('.label_show_variants_score');
        labelShowVariantsScore?.classList.add('d-none');
        const labelUseVariantsFiles = customFieldsParams.querySelector('.label_use_variants_files');
        labelUseVariantsFiles?.classList.add('d-none');
        const labelShuffleVariants = customFieldsParams.querySelector('.label_shuffle_variants');
        labelShuffleVariants?.classList.add('d-none');
      }
    },
    error: function (data) {
      showFormResponse(data);
    },
  });
}

const numberFieldFormatsHandler = function (e) {
  if (!e.target.checked) {
    return;
  }

  const formatInput = e.target;
  const fieldUuid = formatInput.getAttribute('data-custom-field-uuid');
  const fieldUuidAttr = '[data-custom-field-uuid="' + fieldUuid + '"]';
  const customFieldBlock = formatInput.closest('.custom_field_block' + fieldUuidAttr);
  const fieldFormatAttr = '[data-custom-field-format="' + formatInput.getAttribute('data-custom-field-format') + '"]';

  const paramsSelector = '.custom_field_params' + fieldUuidAttr + fieldFormatAttr;
  const params = customFieldBlock.querySelectorAll(paramsSelector);

  params?.forEach(function (paramsBlock) {
    paramsBlock.style.display = 'block';
    const paramsInputs = paramsBlock.querySelectorAll('input');
    paramsInputs.forEach(function (element) {
      element.disabled = false;
    });

    const useVariantsInput = paramsBlock.querySelector('.checkbox_use_variants_score');
    useVariantsInput?.addEventListener('change', function (e) {
      const blocks = paramsBlock.querySelectorAll('.variant_score_block');

      blocks?.forEach(function (block) {
        if (e.target.checked) {
          block.classList.remove('d-none');
        } else {
          block.classList.add('d-none');
        }
      });
    });
  });

  toggleRequiredAndPublicCheckboxes(customFieldBlock, fieldUuid, true);

  disableUncheckedInputs();
};

const textFieldFormatsHandler = function (e) {
  if (!e.target.checked) {
    return;
  }

  const formatInput = e.target;
  const fieldUuid = formatInput.getAttribute('data-custom-field-uuid');
  const fieldUuidAttr = '[data-custom-field-uuid="' + fieldUuid + '"]';
  const customFieldBlock = formatInput.closest('.custom_field_block' + fieldUuidAttr);
  const fieldFormatAttr = '[data-custom-field-format="' + formatInput.getAttribute('data-custom-field-format') + '"]';
  const paramsSelector = '.custom_field_params' + fieldUuidAttr + fieldFormatAttr;
  const params = customFieldBlock.querySelectorAll(paramsSelector);

  params?.forEach(function (paramsBlock) {
    paramsBlock.style.display = 'block';
    const paramsInputs = paramsBlock.querySelectorAll('input');
    paramsInputs.forEach(function (element) {
      element.disabled = false;
    });

    const useVariantsInput = paramsBlock.querySelector('.checkbox_use_variants_score');
    useVariantsInput?.addEventListener('change', function (e) {
      const blocks = paramsBlock.querySelectorAll('.variant_score_block');

      blocks?.forEach(function (block) {
        if (e.target.checked) {
          block.classList.remove('d-none');
        } else {
          block.classList.add('d-none');
        }
      });
    });
  });

  toggleRequiredAndPublicCheckboxes(customFieldBlock, fieldUuid, true);

  disableUncheckedInputs();
};

const attachFieldFormatsHandler = function (e) {
  if (!e.target.checked) {
    return;
  }

  const formatInput = e.target;
  const fieldUuid = formatInput.getAttribute('data-custom-field-uuid');
  const fieldUuidAttr = '[data-custom-field-uuid="' + fieldUuid + '"]';
  const customFieldBlock = formatInput.closest('.custom_field_block' + fieldUuidAttr);
  const fieldFormatAttr = '[data-custom-field-format="' + formatInput.getAttribute('data-custom-field-format') + '"]';

  const paramsSelector = '.custom_field_params' + fieldUuidAttr + fieldFormatAttr;
  const params = customFieldBlock.querySelector(paramsSelector);

  if (!params) {
    return;
  }

  params.style.display = 'block';
  const paramsInputs = params.querySelectorAll('input');
  paramsInputs.forEach(function (element) {
    // @KLUDGE
    // Поля типа Вложение - Любой файл оставляем заблокированным,
    // чтобы оно не отправлялось с каждым другим типом вложения
    if (
      element.name === 'custom_fields[' + fieldUuid + '][work_formats][5][]'
    ) {
      return;
    }

    element.disabled = false;
  });

  const attachFormats = params.querySelectorAll('.attach_field_format' + fieldUuidAttr);

  const attachFormatsHandler = function (e) {
    const attachFormatAttr = '[data-attach-format="' + e.target.getAttribute('data-attach-format') + '"]';
    const attachFileTypeSelect = '.attach_file_type' + fieldUuidAttr + attachFormatAttr;
    const attachFileTypes = document.querySelector(attachFileTypeSelect);
    const inputs = attachFileTypes.querySelectorAll('input');

    if (e.target.checked) {
      attachFileTypes.style.display = 'block';
      inputs.forEach(function (element) {
        element.disabled = false;
      });
    } else {
      attachFileTypes.style.display = 'none';
      inputs.forEach(function (element) {
        element.disabled = true;
      });
    }
  };

  attachFormats.forEach(function (attachFormat) {
    attachFormat.addEventListener('change', attachFormatsHandler);
  });

  toggleRequiredAndPublicCheckboxes(customFieldBlock, fieldUuid, true);

  disableUncheckedInputs();
};

const phoneFieldFormatsHandler = function (e) {

  if (!e.target.checked) {
    return;
  }

  const formatInput = e.target;
  const fieldUuid = formatInput.getAttribute('data-custom-field-uuid');
  const fieldUuidAttr = '[data-custom-field-uuid="' + fieldUuid + '"]';
  const customFieldBlock = formatInput.closest('.custom_field_block' + fieldUuidAttr);

  toggleRequiredAndPublicCheckboxes(customFieldBlock, fieldUuid, true);

  disableUncheckedInputs();
};

const checkboxSelectFieldFormatsHandler = function (e) {

  if (!e.target.checked) {
    return;
  }

  const formatInput = e.target;
  const fieldUuid = formatInput.getAttribute('data-custom-field-uuid');
  const fieldUuidAttr = '[data-custom-field-uuid="' + fieldUuid + '"]';
  const customFieldBlock = formatInput.closest('.custom_field_block' + fieldUuidAttr);
  const fieldFormatAttr = '[data-custom-field-format="' + formatInput.getAttribute('data-custom-field-format') + '"]';
  const paramsSelector = '.custom_field_params' + fieldUuidAttr + fieldFormatAttr;
  const params = customFieldBlock.querySelectorAll(paramsSelector);

  params?.forEach(function (paramsBlock) {
    paramsBlock.style.display = 'block';
    const paramsInputs = paramsBlock.querySelectorAll('input');
    paramsInputs.forEach(function (element) {
      element.disabled = false;
    });

    const limitCheckedInput = paramsBlock.querySelector('.checkbox_limit_checked_variants');
    limitCheckedInput?.addEventListener('change', function (e) {
      const block = paramsBlock.querySelector('.limit_checked_variants_block');

      if (e.target.checked) {
        block.classList.remove('d-none');
      } else {
        block.classList.add('d-none');
      }
    });

    const useVariantsInput = paramsBlock.querySelector('.checkbox_use_variants_score');
    useVariantsInput?.addEventListener('change', function (e) {
      const blocks = paramsBlock.querySelectorAll('.variant_score_block');

      blocks?.forEach(function (block) {
        if (e.target.checked) {
          block.classList.remove('d-none');
        } else {
          block.classList.add('d-none');
        }
      });
    });
  });

  toggleRequiredAndPublicCheckboxes(customFieldBlock, fieldUuid, true);

  disableUncheckedInputs();
};

const tableFieldFormatsHandler = function (e) {
  if (!e.target.checked) {
    return;
  }

  const formatInput = e.target;
  const fieldUuid = formatInput.getAttribute('data-custom-field-uuid');
  const fieldUuidAttr = '[data-custom-field-uuid="' + fieldUuid + '"]';
  const customFieldBlock = formatInput.closest('.custom_field_block' + fieldUuidAttr);
  const fieldFormatAttr = '[data-custom-field-format="' + formatInput.getAttribute('data-custom-field-format') + '"]';

  const paramsSelector = '.custom_field_params' + fieldUuidAttr + fieldFormatAttr;
  const params = customFieldBlock.querySelector(paramsSelector);

  params.style.display = 'block';
  const paramsInputs = params.querySelectorAll('input');
  paramsInputs.forEach(function (element) {
    element.disabled = false;
  });

  toggleRequiredAndPublicCheckboxes(customFieldBlock, fieldUuid, true);

  disableUncheckedInputs();
};

const sectionFieldFormatsHandler = function (e) {
  if (!e.target.checked) {
    return;
  }

  const formatInput = e.target;
  const fieldUuid = formatInput.getAttribute('data-custom-field-uuid');
  const fieldUuidAttr = '[data-custom-field-uuid="' + fieldUuid + '"]';
  const customFieldBlock = formatInput.closest('.custom_field_block' + fieldUuidAttr);

  toggleRequiredAndPublicCheckboxes(customFieldBlock, fieldUuid, false);

  disableUncheckedInputs();
};

function initContestCustomFields() {
  console.log('initContestCustomFields');
  const numberFieldFormats = document.querySelectorAll('.custom_field_format[data-custom-field-format="1"]');
  numberFieldFormats.forEach(function (field) {
    field.addEventListener('change', numberFieldFormatsHandler);
  });

  const textFieldFormats = document.querySelectorAll('.custom_field_format[data-custom-field-format="2"]');
  textFieldFormats.forEach(function (field) {
    field.addEventListener('change', textFieldFormatsHandler);
  });

  const attachFieldFormats = document.querySelectorAll('.custom_field_format[data-custom-field-format="3"]');
  attachFieldFormats.forEach(function (field) {
    field.addEventListener('change', attachFieldFormatsHandler);
  });

  const phoneFieldFormats = document.querySelectorAll('.custom_field_format[data-custom-field-format="4"]');

  phoneFieldFormats.forEach(function (field) {
    field.addEventListener('change', phoneFieldFormatsHandler);
  });

  const checkboxFieldFormats = document.querySelectorAll('.custom_field_format[data-custom-field-format="5"]');
  checkboxFieldFormats.forEach(function (field) {
    field.addEventListener('change', checkboxSelectFieldFormatsHandler);
  });

  const selectFieldFormats = document.querySelectorAll('.custom_field_format[data-custom-field-format="6"]');
  selectFieldFormats.forEach(function (field) {
    field.addEventListener('change', checkboxSelectFieldFormatsHandler);
  });

  const radioFieldFormats = document.querySelectorAll('.custom_field_format[data-custom-field-format="9"]');
  radioFieldFormats.forEach(function (field) {
    field.addEventListener('change', checkboxSelectFieldFormatsHandler);
  });

  const regionFieldFormats = document.querySelectorAll('.custom_field_format[data-custom-field-format="8"]');
  regionFieldFormats.forEach(function (field) {
    field.addEventListener('change', checkboxSelectFieldFormatsHandler);
  });

  const rangeNumberFieldFormats = document.querySelectorAll('.custom_field_format[data-custom-field-format="10"]');
  rangeNumberFieldFormats.forEach(function (field) {
    field.addEventListener('change', checkboxSelectFieldFormatsHandler);
  });

  const tableFieldFormats = document.querySelectorAll('.custom_field_format[data-custom-field-format="11"]');
  tableFieldFormats.forEach(function (field) {
    field.addEventListener('change', tableFieldFormatsHandler);
  });

  const aiImageFieldFormats = document.querySelectorAll('.custom_field_format[data-custom-field-format="12"]');

  const aiImageFieldFormatsHandler = function (e) {
    if (!e.target.checked) {
      return;
    }

    const fieldUuid = e.target.getAttribute('data-custom-field-uuid');

    toggleRequiredAndPublicCheckboxes(fieldUuid, true);
    disableUncheckedInputs(fieldFormats);
  };

  aiImageFieldFormats.forEach(function (field) {
    field.addEventListener('change', aiImageFieldFormatsHandler);
  });

  const aiTextFieldFormats = document.querySelectorAll('.custom_field_format[data-custom-field-format="13"]');
  aiTextFieldFormats.forEach(function (field) {
    field.addEventListener('change', textFieldFormatsHandler);
  });

  const sectionFieldFormats = document.querySelectorAll('.custom_field_format[data-custom-field-format="7"]');
  sectionFieldFormats.forEach(function (field) {
    field.addEventListener('change', sectionFieldFormatsHandler);
  });

  // для работы переключения форматов полей для уже заполненных настраиваемых полей, но не сохраненных
  window.addEventListener('load', function (e) {
    let changeEvent = new Event('change');

    numberFieldFormats.forEach(function (field) {
      if (field.checked) {
        field.dispatchEvent(changeEvent);
      }
    });

    textFieldFormats.forEach(function (field) {
      if (field.checked) {
        field.dispatchEvent(changeEvent);
      }
    });

    attachFieldFormats.forEach(function (field) {
      if (field.checked) {
        field.dispatchEvent(changeEvent);
      }
    });

    phoneFieldFormats.forEach(function (field) {
      if (field.checked) {
        field.dispatchEvent(changeEvent);
      }
    });

    checkboxFieldFormats.forEach(function (field) {
      if (field.checked) {
        field.dispatchEvent(changeEvent);
      }
    });

    selectFieldFormats.forEach(function (field) {
      if (field.checked) {
        field.dispatchEvent(changeEvent);
      }
    });

    radioFieldFormats.forEach(function (field) {
      if (field.checked) {
        field.dispatchEvent(changeEvent);
      }
    });

    regionFieldFormats.forEach(function (field) {
      if (field.checked) {
        field.dispatchEvent(changeEvent);
      }
    });

    rangeNumberFieldFormats.forEach(function (field) {
      if (field.checked) {
        field.dispatchEvent(changeEvent);
      }
    });

    tableFieldFormats.forEach(function (field) {
      if (field.checked) {
        field.dispatchEvent(changeEvent);
      }
    });

    aiImageFieldFormats.forEach(function (field) {
      if (field.checked) {
        field.dispatchEvent(changeEvent);
      }
    });
  });

  // удаление сохраненных настраиваемых полей
  const removeCustomFieldButtons = document.querySelectorAll('.delete_custom_field');
  removeCustomFieldButtons?.forEach(function (button) {
    button.addEventListener('click', removeCustomFieldHandler);
  });

  // удаление заполненных, но не сохраненных настраиваемых полей
  const removeNewCustomFieldButtons = document.querySelectorAll('.delete_filled_custom_field');
  removeNewCustomFieldButtons?.forEach(function (button) {
    button.addEventListener('click', removeNewCustomFieldHandler);
  });

  // Удаление сохраненных вариантов настраиваемых полей с типом checkbox, select
  const removeFieldVariantButtons = document.querySelectorAll('.delete_custom_field_variant');
  removeFieldVariantButtons?.forEach(function (button) {
    button.addEventListener('click', removeFieldVariantHandler);
  });
}

export {
  initContestCustomFields,
  numberFieldFormatsHandler,
  textFieldFormatsHandler,
  attachFieldFormatsHandler,
  phoneFieldFormatsHandler,
  checkboxSelectFieldFormatsHandler,
  sectionFieldFormatsHandler,
  tableFieldFormatsHandler,
  removeCustomFieldHandler,
  removeNewCustomFieldHandler,
  removeFieldVariantHandler
}